export const parseTime = (timeString) => {
  const [time, period] = timeString.split(" ");
  const [hours, minutes] = time.split(":").map(Number);
  const adjustedHours =
    period === "PM" && hours !== 12
      ? hours + 12
      : period === "AM" && hours === 12
        ? 0
        : hours;
  return adjustedHours * 60 + minutes;
};

export const isWithinRange = (currentTime, startTime, endTime) => {
  return (
    currentTime >= parseTime(startTime) && currentTime <= parseTime(endTime)
  );
};

export const isGreater = (currentTime, endTime) => { //validar turno madrugada
  return (
    currentTime > parseTime(endTime)
  );
};

export const getPeruISOStringAtZero = (dateString) => {
  if (dateString) {
    console.log(dateString);
    // Crear un objeto Date con la fecha proporcionada y hora UTC 00:00:00
    const date = new Date(dateString + 'T00:00:00Z'); // Añadimos 'Z' para indicar UTC

    // Ajustar la fecha a la zona horaria de Perú (UTC-5), restando 5 horas
    date.setHours(date.getHours() + 5);

    // Devolver la fecha en formato ISO
    return date.toISOString();
  }

}

export const getPeruISOStringAtEnd = (fechaStr) => {
  if (fechaStr) {
    // Parsear la fecha de entrada (asume formato YYYY-MM-DD)
    const [year, month, day] = fechaStr.split('-').map(Number);

    // Para que en Perú (UTC-5) sea 23:59:59 del día 12
    // en UTC debe ser 04:59:59 del día SIGUIENTE
    const fecha = new Date(Date.UTC(year, month - 1, day + 1, 4, 59, 59));

    return fecha.toISOString();
  }

}

export const getNextDay = (isoString) => {
  // Crear fecha desde el ISO string
  const fecha = new Date(isoString);

  // Agregar 1 segundo para pasar al siguiente día
  // 1000 ms = 1 segundo
  const siguienteDia = new Date(fecha.getTime() + 1000);

  // Ajustar a hora de Perú (UTC-5)
  const fechaPeru = new Date(siguienteDia.toLocaleString('en-US', {
    timeZone: 'America/Lima'
  }));

  // Formatear como YYYY-MM-DD
  const year = fechaPeru.getFullYear();
  const month = String(fechaPeru.getMonth() + 1).padStart(2, '0');
  const day = String(fechaPeru.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
export const getNextDayByStr = (fechaStr) => {
  // Parseamos la fecha, el constructor de Date asume hora local
  // así que agregamos 'T00:00:00' para asegurarnos que sea al inicio del día
  const fecha = new Date(`${fechaStr}T00:00:00`);

  // Agregamos un día
  fecha.setDate(fecha.getDate() + 1);

  // Formateamos de vuelta a YYYY-MM-DD
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export const getPreviousDay = (dateString) => {
  // Create a new Date object using the input string
  // Using local timezone to ensure correct day calculation
  const [year, month, day] = dateString.split('-').map(Number);

  // Create a Date object with the specified date
  const date = new Date(year, month - 1, day);

  // Subtract one day
  date.setDate(date.getDate() - 1);

  // Format the result back to YYYY-MM-DD
  return date.toISOString().split('T')[0];
};

export const changeIsoDateToInputFormat = (fechaStr) => {
  // Si ya está en formato ISO, solo retornamos la parte de la fecha
  if (fechaStr.includes('T')) {
    // Para manejar el caso de ISO string con timezone
    const fecha = new Date(fechaStr);
    return fecha.toLocaleDateString('sv', { // 'sv' nos da formato YYYY-MM-DD
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'America/Lima' // o tu zona horaria
    });
  }

  // Si está en formato MM/DD/YY
  // if (fechaStr.includes('/')) {
  //   const [month, day, year] = fechaStr.split('/');
  //   const fullYear = year.length === 2 ? 
  //     (parseInt(year) < 50 ? '20' + year : '19' + year) : 
  //     year;
  //   return `${fullYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  // }

  // throw new Error('Formato de fecha no soportado');
}
export const formatLocaleUSDateToInputFormat = (fechaStr) => {
  // Convertir de formato MM/DD/YY a un objeto Date
  const [month, day, year] = fechaStr.split('/');

  // Asumimos que años de dos dígitos menores a 50 son 2000s, y 50 o mayores son 1900s
  const fullYear = year.length === 2 ?
    (parseInt(year) < 50 ? '20' + year : '19' + year) :
    year;

  // Crear fecha y formatear
  const fecha = new Date(`${fullYear}-${month}-${day}`);

  // Formatear a YYYY-MM-DD
  return fecha.toISOString().split('T')[0];
}

// export const dateIsAfter = (date1, date2) => {
//   const d1 = new Date(date1);
//   const d2 = new Date(date2);

//   const year1 = d1.getUTCFullYear();
//   const month1 = d1.getUTCMonth();
//   const day1 = d1.getUTCDate();

//   const year2 = d2.getUTCFullYear();
//   const month2 = d2.getUTCMonth();
//   const day2 = d2.getUTCDate();

//   if (year1 < year2 || (year1 === year2 && month1 < month2) || (year1 === year2 && month1 === month2 && day1 < day2)) {
//     return false; // d1 es anterior a d2 //fecha valida
//   }
//   if (year1 > year2 || (year1 === year2 && month1 > month2) || (year1 === year2 && month1 === month2 && day1 > day2)) {
//     return true; // d1 es posterior a d2 // fecha invalida
//   }
//   return false; // d1 y d2 son iguales en términos de fecha //fecha valida
// }

export const dateIsBetween = (initDate, endDate, inputDate) => {

  let inpdate = `${inputDate}`.includes('T')
    ? `${inputDate}`.split('T')[0]
    : `${inputDate}`.includes('/')
      ? (() => {
        const [day, month, year] = `${inputDate}`.split('/').map(Number);
        const formattedDay = String(day).padStart(2, '0');
        const formattedMonth = String(month).padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`;
      })()
      : `${inputDate}`;

  console.log("initDate: ", initDate);
  console.log("endDate: ", endDate);
  console.log("inputDate: ", inputDate);


  let convertedDateForStart = `${inpdate}T05:00:00.000Z`;
  //convertedDateForStart.setHours(convertedDateForStart.getHours() + 5);  // Sumar 5 horas

  // Convertir la fecha de input, sumándole un día y poniéndola a las 4:59:59.000 AM para la comparación con la fecha de fin
  const date_ = new Date(`${inpdate}T05:00:00.000Z`);
  !`${inputDate}`.includes('T') && date_.setDate(date_.getDate() + 1);
  const year = date_.getFullYear();
  const day = String(date_.getDate()).padStart(2, '0');  // Asegurarse de que el día tenga dos dígitos
  const month = String(date_.getMonth() + 1).padStart(2, '0');



  let convertedDateForEnd = `${year}-${month}-${day}T04:59:59.000Z`;

  // Comparar las fechas
  const isValidStart = initDate <= convertedDateForStart;
  const isValidEnd = convertedDateForEnd <= endDate;
  console.log("convertedDateForStart: ", convertedDateForStart);
  console.log("convertedDateForEnd: ", convertedDateForEnd);
  console.log("isValidStart: ", isValidStart);
  console.log("isValidEnd: ", isValidEnd);
  // Si ambas comparaciones son válidas, devolver true
  return isValidStart && isValidEnd;
};


export const dateIsAfter = (date1, date2) => {
  if (date1 != null &&
    date2 != null &&
    date1 !== "" &&
    date2 !== "" &&
    !isNaN(new Date(date1).getTime()) &&
    !isNaN(new Date(date2).getTime())
  ) {
    console.log("date1: ", date1);
    console.log("date2: ", date2);
    // Función para convertir una fecha sin hora a ISO con UTC-5
    const toPeruISODate = (date) => {
      const d = new Date(date); // Crear objeto Date
      d.setUTCHours(5, 0, 0, 0); // Establecer hora 00:00 en UTC-5
      return d;
    };

    // Normalizar ambas fechas
    const d1 = date1?.includes("T") ? new Date(date1) : toPeruISODate(date1);
    const d2 = date2?.includes("T") ? new Date(date2) : toPeruISODate(date2);

    console.log("d1: ", d1);
    console.log("d2: ", d2);

    // Comparar las fechas normalizadas
    return d1 > d2; // Retorna true si d1 es después de d2
  }
  return false; // Agregar esto
};

export const getBlockDates = (initDate, endDate, interval) => {
  if (interval === 0 || interval === "0") { throw new Error("Intervalo no válido") }
  const dates = [];
  let currentDate = new Date(initDate);
  const end = new Date(endDate);

  // Verifica que ambas fechas sean válidas
  if (isNaN(currentDate) || isNaN(end)) {
    console.error("Fechas no válidas");
    return dates;
  }

  while (currentDate <= end) {
    // Formatea la fecha actual en formato ISO
    dates.push(currentDate.toISOString());

    // Incrementa la fecha en el intervalo dado
    currentDate.setDate(currentDate.getDate() + interval);
  }

  return dates;
}

export const sortDates = (fechaStrings) => {
  return fechaStrings.sort((a, b) => {
    return a.localeCompare(b);
  });
}

export const compareDatesIgnoringTime = (fecha1, fecha2) => {
  // Convertir las fechas a objetos Date
  const d1 = new Date(fecha1);
  const d2 = new Date(fecha2);

  // Obtener solo la fecha (sin la hora) en formato 'YYYY-MM-DD'
  const fecha1Solo = d1.toISOString().split('T')[0];
  const fecha2Solo = d2.toISOString().split('T')[0];
  console.log("fechas a comprar: ", fecha1Solo, fecha2Solo);
  // Comparar las fechas sin considerar la hora
  return fecha1Solo === fecha2Solo;
}